import { useState, useEffect } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  Flex,
  Heading,
  Button,
  ButtonGroup,
  IconButton,
  Box,
} from "@chakra-ui/react";
import { crm } from "../../../theme";
import { FaCompress, FaEye, FaHistory, FaPencilAlt } from "react-icons/fa";
import TableNoWithPagination from "../../../components/TableNoWithPagination";
import { columns } from "./columns";
import { ProcessViewModel } from "../../../models/Process";

interface FullscreenTableModalProps {
  isOpen: boolean;
  onClose: () => void;
  visibleColumns: typeof columns;
  tags: any[];
  isAdmin: boolean;
  onCellEdit: (rowId: any, index: string, newValue: any) => Promise<void>;
  onOpenApprove: () => void;
  setSelectedProcess: (process: ProcessViewModel) => void;
  onColumnReorder: (fromLabel: string, toLabel: string) => void;
  get: (
    localPageSize?: number,
    localPageNumber?: number,
    sortField?: string,
    sortDirection?: string,
  ) => Promise<any>;
}

const FullscreenTableModal = ({
  isOpen,
  onClose,
  visibleColumns,
  tags,
  isAdmin,
  onCellEdit,
  onOpenApprove,
  setSelectedProcess,
  onColumnReorder,
  get,
}: FullscreenTableModalProps) => {
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    if (isOpen && !initialized) {
      setInitialized(true);
    }

    if (!isOpen) {
      setInitialized(false);
    }
  }, [isOpen]);

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="full">
      <ModalOverlay />
      <ModalContent margin={0} borderRadius={0}>
        <ModalBody
          p="16px"
          display="flex"
          flexDirection="column"
          height="100vh"
        >
          <Flex justifyContent="space-between" alignItems="center" mb="16px">
            <Heading size="md" fontWeight="normal">
              Processos — Tela cheia
            </Heading>
            <Button
              color="white"
              borderRadius="10px"
              backgroundColor={crm.brand}
              _hover={{ backgroundColor: crm.brandDark }}
              onClick={onClose}
            >
              <Flex justifyContent="center" alignItems="center" gap="8px">
                <FaCompress color="white" /> Sair da tela cheia
              </Flex>
            </Button>
          </Flex>
          <Box flex="1" overflowY="auto">
            {initialized && (
              <TableNoWithPagination
                onCellEdit={onCellEdit}
                isProcess
                get={get}
                tags={tags}
                reorderable
                onColumnReorder={onColumnReorder}
                columns={[
                  ...visibleColumns,
                  {
                    label: "",
                    data: (p: any) => (
                      <ButtonGroup>
                        <a href={`/saveProcess?id=${p?.id}`}>
                          <IconButton
                            backgroundColor={crm.brand}
                            color="white"
                            aria-label="Editar"
                            icon={<FaPencilAlt />}
                          />
                        </a>
                        {isAdmin && (
                          <IconButton
                            backgroundColor={crm.brand}
                            color="white"
                            onClick={() => {
                              setSelectedProcess(p);
                              onOpenApprove();
                            }}
                            aria-label="Histórico"
                            icon={<FaHistory />}
                          />
                        )}
                        <a href={`/process?id=${p.id}`}>
                          <IconButton
                            backgroundColor={crm.brand}
                            color="white"
                            aria-label="Ver detalhes"
                            icon={<FaEye />}
                          />
                        </a>
                      </ButtonGroup>
                    ),
                  },
                ]}
                emptyMessage="Não há processos ainda"
              />
            )}
          </Box>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default FullscreenTableModal;
